<template>
  <div>
    <router-link :to="{name: 'item-create' }" class="button is-primary is-pulled-right">
      Add item
    </router-link>
    <data-table :data-set="items" :columns="[
            {name: 'i', type: 'text', searchable: false, prop: 'image_id'},
            {name: 'Name', type: 'text', prop: 'name'},
            {name: 'Updated', type: 'date', prop: 'updated_at', filter: ['moment', ['from', 'now']]},
            {name: 'Created', type: 'date', prop: 'created_at', filter: ['moment', ['from', 'now']]},
        ]">
      <template slot="column_i" slot-scope="props">
        <div class="data-images">
          <img v-if="props.row.image_id" :src="getImage(props.row.image_id).thumbnail_path" class="data-image">
        </div>
      </template>
      <template slot="column_Name" slot-scope="props">
        <router-link :to="{name: 'item', params:{id:props.row.id}}">
          {{ props.row.name }}
        </router-link>
      </template>
      <template slot="controls" slot-scope="props">
        <td>
          <div class="has-text-right">
            <a class="delete" @click="deleteItem(props.row)"></a>
          </div>
        </td>
      </template>
    </data-table>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { DELETE_ITEM } from "../../../store/mutation-types";

export default {
  name: 'item-list',
  data() {
    return {}
  },
  computed: mapGetters(['items', 'images']),
  methods: {
    getImage(image_id) {
      return this.images.find(image => image.id === image_id)
    },
    deleteItem(item) {
      this.$store.dispatch(DELETE_ITEM, item)
    },
  },
}
</script>



// WEBPACK FOOTER //
// ItemList.vue?1b1f3fc6